import React, { useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, X } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

const STORAGE_KEY_PREFIX = "rollops_banner_dismissed_";

export const ExpiringBanner = () => {
  const { user } = useAuth();
  const s = user?.plan_status;
  const [dismissed, setDismissed] = useState(() => {
    if (typeof window === "undefined" || !s) return false;
    return sessionStorage.getItem(STORAGE_KEY_PREFIX + Math.floor(s.days_left / 1)) === "1";
  });

  if (!s) return null;
  // Show: expired OR < 7 days remaining
  const expiring = s.is_active && s.days_left <= 7;
  const expired = !s.is_active;
  if (!expiring && !expired) return null;
  if (dismissed && expiring) return null;

  const tone = expired
    ? { bg: "rgba(255,59,48,0.10)", border: "#FF3B30", text: "#FFD9D6", accent: "#FF3B30" }
    : { bg: "rgba(255,159,10,0.10)", border: "#FF9F0A", text: "#FFE7B8", accent: "#FF9F0A" };

  const msg = expired
    ? "Your plan has expired. You can still view existing positions but cannot add new ones."
    : `Your ${s.status_label.toLowerCase()} plan ends in ${s.days_left} day${s.days_left === 1 ? "" : "s"}. Renew now to keep adding positions and avoid interruption.`;

  const dismiss = () => {
    sessionStorage.setItem(STORAGE_KEY_PREFIX + Math.floor(s.days_left / 1), "1");
    setDismissed(true);
  };

  return (
    <div
      data-testid="expiring-banner"
      className="flex items-center gap-3 px-3 py-2 border-l-2"
      style={{ background: tone.bg, borderColor: tone.border, color: tone.text }}
    >
      <AlertTriangle size={14} style={{ color: tone.accent }} className="flex-shrink-0" />
      <span className="text-xs flex-1 leading-tight">{msg}</span>
      <Link
        to="/billing"
        data-testid="banner-renew-btn"
        className="text-[11px] font-semibold uppercase tracking-wider px-3 py-1.5 transition-colors"
        style={{ background: tone.accent, color: "#000" }}
      >
        {expired ? "Renew now" : "Renew"}
      </Link>
      {expiring && !expired && (
        <button
          data-testid="banner-dismiss-btn"
          onClick={dismiss}
          className="text-[#A1A1AA] hover:text-white transition-colors p-1"
          aria-label="Dismiss"
        >
          <X size={12} />
        </button>
      )}
    </div>
  );
};
